import React, { Component } from 'react';

import Header from './components/header/Header';
import Navigation from './components/navigation/Navigation';
import AppContent from './components/appContent/AppContent';
import Footer from './components/footer/Footer';

import styles from './App.module.scss';


class App extends Component {
  render() {
    return (
      <div className={styles.App}>
        <Navigation/>
        <Header/>
        <AppContent/>
        <Footer/>
      </div>
    );
  }
}

export default App;
